<template>
  <div>
    <el-container>
      <el-header class="app-header">
        <heads></heads>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <el-footer>
        <footers></footers>
      </el-footer>
      <!-- <router-view /> -->
    </el-container>
  </div>
</template>

<script>
import heads from "./common/header.vue";
import mains from "./common/main.vue";
// import Tyd from "./project/Tyd.vue";
// import Smartrent from "./project/Smartrent.vue";
import footers from "./common/footer.vue";
export default {
  name: "home",
  components: {
    heads,
    mains,
    // Tyd,
    // Smartrent,
    footers,
  },
  created() {
    // 在组件加载时跳转到 /main
    // this.$router.push('/main');
  },
  mounted() {
    window.addEventListener("scroll", function () {
      const backToTop = document.querySelector(".app-header");
      if (window.scrollY > 300) {
        backToTop.classList.add("show-app-header");
      } else {
        backToTop.classList.remove("show-app-header");
      }
    });
  },
  methods: {},
};
</script>

<style>
html,
body {
  padding: 0;
  margin: 0;
}

.el-header {
  width: 100%;
  height: 70px !important;
  /* background: rgb(77, 76, 76); */
  background: rgb(116 118 118);
  opacity: 0.9;
  position: fixed;
  top: 0;
  z-index: 999;
}

.app-header {
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
}

.show-app-header {
  opacity: 0;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue